import React from 'react'
import { MaintenancePage } from './MaintenancePage'

export const MaintenanceLayout: React.FC<{
    children: React.ReactNode
}> = () => {
    return <MaintenancePage />
}
